import type { Message } from './chatTypes';

/** Returns whether a BE role string is supported by the FE message union. */
export const isValidMessageRole = (role: string): role is Message['role'] =>
  role === 'user' ||
  role === 'assistant' ||
  role === 'system' ||
  role === 'tool';
